import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';

export const walletUserStop = http.patch(
  createMockEndpoint('/wallet_user/:id/stop'),
  async () => {
    await delay(500);
    return HttpResponse.json(null, { status: 200 });
  },
);
